import Store from 'store'
window.onpopstate = function(event){
    if (document.querySelector(".nti-webshop-main-content"))
    {
        const selectedFacetsForStore = event.state
        Store.commit('search/setSelectedFacets',selectedFacetsForStore)
        Store.dispatch('search/performSearch')
    }
}
